'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _nuiIntl = require('@concur/nui-intl');

var _reactRouter = require('react-router');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactModal = require('react-modal');

var _reactModal2 = _interopRequireDefault(_reactModal);

var _find2 = require('lodash/find');

var _find3 = _interopRequireDefault(_find2);

var _has2 = require('lodash/has');

var _has3 = _interopRequireDefault(_has2);

!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require('./style/terms.css') : void 0;

var _TermsPanel = require('./TermsPanel');

var _TermsPanel2 = _interopRequireDefault(_TermsPanel);

var _analytics = require('../constants/analytics');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TandC = function TandC(_ref) {
  var terms = _ref.terms,
      userId = _ref.userId,
      toggleModal = _ref.toggleModal,
      toggleNeedAnAccountClicked = _ref.toggleNeedAnAccountClicked,
      updateTermsStatus = _ref.updateTermsStatus,
      connect = _ref.connect,
      postTerms = _ref.postTerms,
      listingId = _ref.listingId,
      v1ListingId = _ref.v1ListingId,
      flow = _ref.flow,
      _ref$partnerAppScopes = _ref.partnerAppScopes,
      partnerAppScopes = _ref$partnerAppScopes === undefined ? [] : _ref$partnerAppScopes,
      clientOptInType = _ref.clientOptInType,
      listing = _ref.listing,
      router = _ref.router,
      formatter = _ref.formatter,
      trackButtonClick = _ref.trackButtonClick,
      trackLinkClick = _ref.trackLinkClick,
      companyUUID = _ref.companyUUID;
  var isTaCModalOpen = terms.isTaCModalOpen,
      content = terms.content,
      appcenterStatus = terms.appcenterStatus,
      sharedInfoStatus = terms.sharedInfoStatus,
      sharedInfo = terms.sharedInfo,
      loa = terms.loa,
      tAndCLinkClicked = terms.tAndCLinkClicked;
  var _listing$data = listing[(0, _has3.default)(listing, listingId) ? listingId : v1ListingId].data;
  _listing$data = _listing$data === undefined ? {} : _listing$data;
  var _listing$data$core = _listing$data.core;
  _listing$data$core = _listing$data$core === undefined ? {} : _listing$data$core;
  var listingName = _listing$data$core.listingName,
      _listing$data$localiz = _listing$data.localized;
  _listing$data$localiz = _listing$data$localiz === undefined ? {} : _listing$data$localiz;
  var partnerPolicyURL = _listing$data$localiz.partnerPolicyURL,
      partnerTermsURL = _listing$data$localiz.partnerTermsURL;


  var style = {
    overlay: {
      zIndex: '100',
      position: 'fixed',
      backgroundColor: 'rgba(0, 0, 0, 0.5)'
    },
    content: {
      position: 'initial',
      width: '600px',
      maxHeight: '80%',
      margin: '75px auto'
    }
  };

  var ADMIN = 'ADMIN';

  var handleClickTermsLearnMoreLink = function handleClickTermsLearnMoreLink(e) {
    trackLinkClick({
      elementPath: [[_analytics.listingConst, listingName].join(' '), _analytics.termsAndConditions, _analytics.learnMoreSharedInfoLink],
      dimensions: {
        listingId: listingId,
        listingName: listingName,
        companyUUID: companyUUID
      }
    });
  };
  var createHTMLMarkup = function createHTMLMarkup(html) {
    return { __html: html };
  };

  var handleCheckboxUpdate = function handleCheckboxUpdate(e) {
    updateTermsStatus(e.target.id, e.target.checked);
  };

  var AppCenterTerms = _react2.default.createElement(
    _TermsPanel2.default,
    {
      checkboxId: 'appcenterStatus',
      title: formatter.formattedMessage({ id: 'TermsAppCenterTitle' }),
      description: formatter.formattedMessage({ id: 'TermsAppCenterDescription' }),
      checked: appcenterStatus.currentlyAccepted,
      onChange: handleCheckboxUpdate,
      showCheckbox: !tAndCLinkClicked
    },
    _react2.default.createElement('div', {
      dangerouslySetInnerHTML: createHTMLMarkup((0, _find3.default)(content, { type: 'appcenter' }).content)
    })
  );

  var concurPrivacyPolicy = _react2.default.createElement(
    'a',
    { target: '_blank', href: 'https://www.concur.com/en-us/processor-privacy-statement' },
    formatter.formattedMessage({ id: 'ProcessorPrivacyStatement' })
  );
  var linkToPartnerPolicy = partnerPolicyURL ? _react2.default.createElement(
    'a',
    { target: '_blank', href: partnerPolicyURL },
    _react2.default.createElement(_nuiIntl.FormattedMessage, { id: 'PartnerPolicyURL' })
  ) : _react2.default.createElement(_nuiIntl.FormattedMessage, { id: 'PartnerPolicyURL' });

  var sharedInfoTerms = _react2.default.createElement(
    _TermsPanel2.default,
    {
      checkboxId: 'sharedInfoStatus',
      title: formatter.formattedMessage({ id: 'TermsAccessAuthTitle' }),
      description: formatter.formattedMessage({ id: 'TermsAccessAuthDescription' }),
      checked: sharedInfoStatus.currentlyAccepted,
      onChange: handleCheckboxUpdate,
      showCheckbox: !tAndCLinkClicked
    },
    _react2.default.createElement(
      'p',
      null,
      clientOptInType !== ADMIN ? _react2.default.createElement(_nuiIntl.FormattedMessage, { id: 'TermsAccessAuthSubtitle' }) : _react2.default.createElement(_nuiIntl.FormattedMessage, { id: 'TermsAccessAuthSubtitleEnterprise' }),
      _react2.default.createElement(
        'span',
        null,
        '\xA0',
        _react2.default.createElement(
          'a',
          { target: '_blank', href: 'https://developer.concur.com/api-reference/authentication/app-center-learn-more.html', onClick: handleClickTermsLearnMoreLink },
          _react2.default.createElement(_nuiIntl.FormattedMessage, { id: 'LearnMoreAboutServiceFieldExposed' })
        )
      )
    ),
    _react2.default.createElement(
      'ul',
      null,
      sharedInfo.map(function (el, i) {
        return _react2.default.createElement(
          'li',
          { className: 'shared-bullet', key: i },
          el
        );
      })
    ),
    _react2.default.createElement(
      'p',
      null,
      _react2.default.createElement(_nuiIntl.FormattedMessage, {
        id: 'ConcurValuesPrivacy',
        values: { concurPrivacyPolicy: concurPrivacyPolicy, linkToPartnerPolicy: linkToPartnerPolicy }
      })
    )
  );

  var LOATerms = _react2.default.createElement(
    _TermsPanel2.default,
    {
      checkboxId: 'loaStatus',
      showCheckbox: !tAndCLinkClicked,
      checked: loa && loa.status.currentlyAccepted,
      onChange: handleCheckboxUpdate,
      title: formatter.formattedMessage({ id: 'AccessAuthorization' }),
      description: formatter.formattedMessage({ id: 'AccessAuthorizationDescription' })
    },
    _react2.default.createElement('div', {
      dangerouslySetInnerHTML: createHTMLMarkup(loa && loa.content && loa.content.html)
    })
  );

  var isNUI = window.location.pathname.indexOf('nui') >= 0;
  var loaLink = (isNUI ? '/nui' : '') + '/appcenter/terms/loa';

  var linkToPartnerTerms = partnerTermsURL ? _react2.default.createElement(
    'a',
    { target: '_blank', href: partnerTermsURL },
    _react2.default.createElement(_nuiIntl.FormattedMessage, { id: 'PartnerTermsURL' })
  ) : _react2.default.createElement(_nuiIntl.FormattedMessage, { id: 'PartnerTermsURL' });

  var linkToLoaTerms = _react2.default.createElement(
    'a',
    { target: '_blank', href: loaLink },
    _react2.default.createElement(_nuiIntl.FormattedMessage, { id: 'AccessAuthorization' })
  );

  var getContent = function getContent() {
    return _react2.default.createElement(
      'div',
      null,
      _react2.default.createElement(
        'div',
        { className: 'col-xs-12', style: { padding: '0px' } },
        _react2.default.createElement(
          'h3',
          null,
          formatter.formattedMessage({ id: 'TermsReview' })
        ),
        _react2.default.createElement(
          'p',
          null,
          _react2.default.createElement(_nuiIntl.FormattedMessage, {
            id: clientOptInType === ADMIN ? "TermsByAcceptEnterprise" : "TermsByAccept",
            values: { loaTermsURL: linkToLoaTerms, partnerTermsURL: linkToPartnerTerms }
          })
        )
      ),
      _react2.default.createElement(
        'div',
        { className: 'col-xs-12', style: { padding: '0px' } },
        tAndCLinkClicked || !appcenterStatus.previouslyAccepted ? AppCenterTerms : null,
        tAndCLinkClicked || flow !== 'WEBFLOW' ? sharedInfoTerms : null,
        clientOptInType === ADMIN && (tAndCLinkClicked || !loa.status.previouslyAccepted) ? LOATerms : null
      )
    );
  };

  var handleCancelClick = function handleCancelClick(e) {
    trackButtonClick({
      elementPath: [[_analytics.listingConst, listingName].join(' '), _analytics.termsAndConditions, _analytics.button.cancel],
      dimensions: {
        listingId: listingId,
        listingName: listingName,
        companyUUID: companyUUID
      }
    });
    e.preventDefault();
    toggleNeedAnAccountClicked(false);
    updateTermsStatus('appcenterStatus', false);
    updateTermsStatus('sharedInfoStatus', false);
    updateTermsStatus('loaStatus', false);
    return toggleModal(false);
  };

  var renderButtons = function renderButtons() {
    // I wish these could be in Promise.all()
    // but connect has to be REALLY close to the user clicking
    // or else chrome blocks the popup
    var handleActpBtnClk = function handleActpBtnClk() {
      trackButtonClick({
        elementPath: [[_analytics.listingConst, listingName].join(' '), _analytics.termsAndConditions, _analytics.button.accept],
        dimensions: {
          listingId: listingId,
          listingName: listingName,
          companyUUID: companyUUID
        }
      });
      postTerms(userId, 'appcenter');
      if (clientOptInType === ADMIN) {
        postTerms(userId, 'loa');
      }
      toggleModal();
      updateTermsStatus('sharedInfoStatus', false);
      return connect(listingId, v1ListingId, userId);
    };

    // Button is disabled unless appcenter terms are previously or currently
    // accepted and shared info is currently accepted
    var renderAcceptBtn = function renderAcceptBtn() {
      var disabledBtn = _react2.default.createElement(
        'button',
        { className: 'btn btn-default btn-lg', disabled: true },
        _react2.default.createElement(_nuiIntl.FormattedMessage, { id: 'IAgree' })
      );

      // TODO: do we even need to check previous if we set current = previous on fetch?
      if (!appcenterStatus.currentlyAccepted && !appcenterStatus.previouslyAccepted) {
        return disabledBtn;
      }
      if (!sharedInfoStatus.currentlyAccepted && flow !== 'WEBFLOW') {
        return disabledBtn;
      }
      if (!loa.status.currentlyAccepted && !loa.status.previouslyAccepted && clientOptInType === ADMIN) {
        return disabledBtn;
      }
      return _react2.default.createElement(
        'button',
        { className: 'btn btn-default btn-lg', onClick: handleActpBtnClk },
        _react2.default.createElement(_nuiIntl.FormattedMessage, { id: 'IAgree' })
      );
    };

    return _react2.default.createElement(
      'div',
      { className: 'tandc-buttons' },
      _react2.default.createElement(
        'a',
        { href: '#', onClick: handleCancelClick },
        _react2.default.createElement(_nuiIntl.FormattedMessage, { id: 'Cancel' })
      ),
      renderAcceptBtn()
    );
  };

  _reactModal2.default.setAppElement('#root');
  return _react2.default.createElement(
    'div',
    { className: 'modal-container' },
    _react2.default.createElement(
      _reactModal2.default,
      {
        style: style,
        isOpen: isTaCModalOpen,
        onRequestClose: toggleModal.bind(null, false),
        contentLabel: 'Terms for connecting to listing modal'
      },
      _react2.default.createElement(
        'div',
        { className: 'row inside-modal' },
        _react2.default.createElement(
          'div',
          { className: 'col-xs-12' },
          _react2.default.createElement(
            'span',
            {
              className: 'close-tandc-modal pull-right',
              onClick: handleCancelClick
            },
            '\xD7'
          ),
          _react2.default.createElement(
            'h2',
            null,
            formatter.formattedMessage({ id: 'TermsTitle' })
          ),
          _react2.default.createElement('hr', null),
          getContent(),
          _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'div',
              { className: 'col-xs-12 tc-hr no-padding' },
              !tAndCLinkClicked && _react2.default.createElement('hr', null)
            ),
            _react2.default.createElement(
              'div',
              { className: 'col-xs-12 no-padding' },
              !tAndCLinkClicked && renderButtons(appcenterStatus, sharedInfoStatus)
            )
          )
        )
      )
    )
  );
};

TandC.contextTypes = { nuiIntl: _propTypes2.default.object };

TandC.propTypes = {
  terms: _propTypes2.default.shape({
    isTaCModalOpen: _propTypes2.default.bool,
    appcenterTerms: _propTypes2.default.string,
    ereceiptStatus: _propTypes2.default.object,
    appcenterStatus: _propTypes2.default.object,
    sharedInfoStatus: _propTypes2.default.object,
    sharedInfo: _propTypes2.default.array,
    tAndCLinkClicked: _propTypes2.default.bool
  }).isRequired,
  flow: _propTypes2.default.string,
  clientOptInType: _propTypes2.default.string,
  listing: _propTypes2.default.object, // eslint-disable-line react/forbid-prop-types
  router: _propTypes2.default.any, // eslint-disable-line react/forbid-prop-types
  listingId: _propTypes2.default.string,
  v1ListingId: _propTypes2.default.string,
  userId: _propTypes2.default.string,
  toggleModal: _propTypes2.default.func.isRequired,
  toggleNeedAnAccountClicked: _propTypes2.default.func,
  updateTermsStatus: _propTypes2.default.func.isRequired,
  connect: _propTypes2.default.func.isRequired,
  postTerms: _propTypes2.default.func.isRequired,
  partnerAppScopes: _propTypes2.default.array, // eslint-disable-line react/forbid-prop-types
  formatter: _propTypes2.default.object, // eslint-disable-line react/forbid-prop-types
  trackButtonClick: _propTypes2.default.func,
  trackLinkClick: _propTypes2.default.func,
  companyUUID: _propTypes2.default.string
};

exports.default = (0, _reactRouter.withRouter)((0, _nuiIntl.withFormatter)(TandC));


//////////////////
// WEBPACK FOOTER
// ./lib/terms/TermsAndConditions.js
// module id = 589
// module chunks = 0